/*
 * Module for handling a single campaign and its data
 */

define(["marionette", "messaging/messenger", "./campaignInfoView"], function (
  Marionette,
  Messenger,
  CampaignInfoView,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "campaignInfo";
      this.region = options.region;
      this.campaign = options.model;
    },
    show: function () {
      this.view = new CampaignInfoView.campaignInfoView({ model: this.campaign });

      this.view.on("delete:new:campaign", (args) => {
        //reset region view
        Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
        Messenger.vent.trigger("delete:campaign", args.model);
        this.region.reset();
      });

      this.showRegion(this.view);
    },
  });
});
